/**
 * Official brand glyphs for OAuth buttons. Brand guidelines mandate
 * specific hex palettes, so these are the one place in the codebase
 * where raw hex is legitimate - that's why they live in features/ and
 * not pages/ (ESLint blocks hex literals in page files).
 */

export function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="size-4">
      <path
        fill="#EA4335"
        d="M12 10.2v3.9h5.5c-.25 1.35-1.5 3.95-5.5 3.95-3.3 0-6-2.75-6-6.05s2.7-6.05 6-6.05c1.9 0 3.15.8 3.85 1.5l2.6-2.55C16.85 3.4 14.65 2.5 12 2.5 6.75 2.5 2.5 6.75 2.5 12s4.25 9.5 9.5 9.5c5.5 0 9.15-3.85 9.15-9.3 0-.6-.05-1.1-.15-1.55H12z"
      />
      <path
        fill="#4285F4"
        d="M21.65 12.2c0-.6-.05-1.1-.15-1.55H12v3.9h5.5c-.25 1.35-1 2.5-2.1 3.25l3.4 2.6c2-1.85 3.15-4.55 3.15-8.2z"
      />
      <path
        fill="#FBBC05"
        d="M5.5 14.45 2.1 16.95C3.8 20.25 7.65 22.5 12 22.5c2.7 0 5-.85 6.65-2.35l-3.4-2.6c-.95.65-2.2 1.05-3.25 1.05-2.5 0-4.6-1.7-5.35-4.0l-1.15-.15z"
      />
      <path
        fill="#34A853"
        d="M2.1 7.05 5.5 9.55c.75-2.3 2.85-4 5.35-4 1.45 0 2.45.6 3 1.1l2.35-2.3C14.85 3.35 12.65 2.5 10 2.5 5.65 2.5 1.8 4.75.1 8.05l2 -1z"
      />
    </svg>
  )
}

export function MicrosoftGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="size-4">
      <path fill="#F25022" d="M2 2h9.5v9.5H2z" />
      <path fill="#7FBA00" d="M12.5 2H22v9.5h-9.5z" />
      <path fill="#00A4EF" d="M2 12.5h9.5V22H2z" />
      <path fill="#FFB900" d="M12.5 12.5H22V22h-9.5z" />
    </svg>
  )
}
